import React from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { Accordion, Card } from "react-bootstrap";
import "../faq/faq.css";

const PatientInformation = () => {
  return (
    <div id="patient-info">
      <div className="about">
        <h1 className="pt-3 text-center font-details pb-2">Información para Pacientes</h1>
        <Container>
          <Row>
            <Col>
              <Accordion defaultActiveKey="0" className="faq-accordion mt-4">
                <Card>
                  <Accordion.Toggle as={Card.Header} eventKey="0">
                    <strong>¿Qué es una crisis vaso oclusiva?</strong>
                  </Accordion.Toggle>
                  <Accordion.Collapse eventKey="0">
                    <Card.Body>
                      <p>
                        Es la complicación más común en personas con drepanocitosis. Los glóbulos rojos adoptan una forma de medialuna y por lo tanto son más rígidos, esto genera un bloqueo al paso de la sangre por los pequeños vasos sanguíneos, causando dolor, daño en los tejidos y dificultad para que el oxígeno llegue donde se necesita.
                      </p>
                    </Card.Body>
                  </Accordion.Collapse>
                </Card>

                <Card>
                  <Accordion.Toggle as={Card.Header} eventKey="1">
                    <strong>¿Cómo se presenta una crisis vaso oclusiva?</strong>
                  </Accordion.Toggle>
                  <Accordion.Collapse eventKey="1">
                    <Card.Body>
                      <p>Dolor intenso en huesos, pecho, abdomen o articulaciones. Puede estar precedido de hormigueo, entumecimiento o ser de inicio súbito.</p>
                      <p>En algunos casos, se puede acompañar de fiebre, vómitos o aumento de volumen en los sitios de dolor.</p>
                      <p>El dolor puede durar desde unas horas hasta varios días.</p>
                    </Card.Body>
                  </Accordion.Collapse>
                </Card>

                <Card>
                  <Accordion.Toggle as={Card.Header} eventKey="2">
                    <strong>¿Qué debo hacer en casa si tengo una crisis de dolor?</strong>
                  </Accordion.Toggle>
                  <Accordion.Collapse eventKey="2">
                    <Card.Body>
                      <ul>
                        <li>Ofrecer líquidos (agua, jugos, caldos).</li>
                        <li>Administrar tratamiento analgésico indicado por su médico (por ejemplo, acetaminofén o ibuprofeno).</li>
                        <li>Aplicar compresas calientes (calor local).</li>
                        <li>Mantener reposo.</li>
                      </ul>
                    </Card.Body>
                  </Accordion.Collapse>
                </Card>

                <Card>
                  <Accordion.Toggle as={Card.Header} eventKey="3">
                    <strong>¿Las crisis vaso oclusivas se pueden prevenir?</strong>
                  </Accordion.Toggle>
                  <Accordion.Collapse eventKey="3">
                    <Card.Body>
                      <ul>
                        <li>Hidratación adecuada todos los días.</li>
                        <li>Evitar el frío, el estrés y la deshidratación.</li>
                        <li>Utilizando medicamentos como la hidroxiurea, si lo recomienda su hematólogo.</li>
                      </ul>
                    </Card.Body>
                  </Accordion.Collapse>
                </Card>

                <Card>
                  <Accordion.Toggle as={Card.Header} eventKey="4">
                    <strong>¿Cuándo debo acudir al hospital?</strong>
                  </Accordion.Toggle>
                  <Accordion.Collapse eventKey="4">
                    <Card.Body>
                      <ul>
                        <li>El dolor abdominal muy fuerte o en cualquier otra parte del cuerpo que no mejora con los medicamentos en casa.</li>
                        <li>Presenta fiebre mayor de 38°C.</li>
                        <li>Dificultad para respirar o dolor en el pecho.</li>
                        <li>Ictericia (piel y ojos amarillos).</li>
                        <li>Vómitos persistentes o sangre en las heces.</li>
                        <li>Abdomen distendido o muy duro.</li>
                        <li>Está muy pálido, débil o somnoliento.</li>
                        <li>Presenta hinchazón en el abdomen o cualquier parte del cuerpo.</li>
                      </ul>
                    </Card.Body>
                  </Accordion.Collapse>
                </Card>

                <Card>
                  <Accordion.Toggle as={Card.Header} eventKey="5">
                    <strong>¿Pueden los pacientes con drepanocitosis hacer actividad física?</strong>
                  </Accordion.Toggle>
                  <Accordion.Collapse eventKey="5">
                    <Card.Body>
                      <p>
                        La actividad física debe ser parte de la vida de cualquier ser humano en cualquier etapa de la vida. Los pacientes con drepanocitosis no deben ser la excepción.
                      </p>
                    </Card.Body>
                  </Accordion.Collapse>
                </Card>

                <Card>
                  <Accordion.Toggle as={Card.Header} eventKey="6">
                    <strong>¿Cuánto tiempo de actividad física es recomendable según la edad?</strong>
                  </Accordion.Toggle>
                  <Accordion.Collapse eventKey="6">
                    <Card.Body>
                      <ul>
                        <li>Bebés que no caminan: deben estar físicamente activos varias veces al día, de diversas formas, a través de juegos interactivos en el suelo. Más es mejor.</li>
                        <li>Menores de 5 años: deben acumular 180 minutos al día de una variedad de actividades físicas de intensidad leve a moderada.</li>
                        <li>De 5 a 18 años: deben acumular 60 minutos al día de una variedad de actividades físicas de intensidad moderada.</li>
                        <li>Adultos de 18 años o más: deben acumular al menos 150-300 minutos de actividades de intensidad moderada por semana (3-5 días).</li>
                      </ul>
                    </Card.Body>
                  </Accordion.Collapse>
                </Card>

                <Card>
                  <Accordion.Toggle as={Card.Header} eventKey="7">
                    <strong>¿Qué se considera una actividad de intensidad moderada?</strong>
                  </Accordion.Toggle>
                  <Accordion.Collapse eventKey="7">
                    <Card.Body>
                      <p>Una forma subjetiva de medir si la intensidad de la actividad es moderada es que, cuando la realiza, puede hablar, pero no cantar.</p>
                      <p>Cuando la actividad física es intensa, el paciente no puede cantar ni hablar, pero esta intensidad es la que queremos evitar en pacientes con drepanocitosis.</p>
                    </Card.Body>
                  </Accordion.Collapse>
                </Card>

                <Card>
                  <Accordion.Toggle as={Card.Header} eventKey="8">
                    <strong>¿Qué es priapismo?</strong>
                  </Accordion.Toggle>
                  <Accordion.Collapse eventKey="8">
                    <Card.Body>
                      <p>
                        Es una complicación grave de la drepanocitosis, consiste en una erección prolongada y dolorosa, que afecta a un porcentaje significativo de pacientes, hasta un 40% en algunos estudios. Puede causar disfunción eréctil si no se trata a tiempo.
                      </p>
                    </Card.Body>
                  </Accordion.Collapse>
                </Card>

                <Card>
                  <Accordion.Toggle as={Card.Header} eventKey="9">
                    <strong>¿Cómo saber si tengo priapismo y debo de ir a emergencias?</strong>
                  </Accordion.Toggle>
                  <Accordion.Collapse eventKey="9">
                    <Card.Body>
                      <p>El priapismo en pacientes con drepanocitosis requiere tratamiento médico urgente. Es crucial buscar atención médica si la erección dura más de 4 horas.</p>
                    </Card.Body>
                  </Accordion.Collapse>
                </Card>
              </Accordion>
            </Col>
          </Row>
        </Container>
        <br />
        <br />
      </div>
    </div>
  );
};

export default PatientInformation;
